var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20825 8.625C1.95617 8.625 1.74037 8.53524 1.56086 8.35573C1.38134 8.17622 1.29159 7.96042 1.29159 7.70833V1.75H0.833252V0.833333H3.12492V0.375H5.87492V0.833333H8.16658V1.75H7.70825V7.70833C7.70825 7.96042 7.61849 8.17622 7.43898 8.35573C7.25947 8.53524 7.04367 8.625 6.79159 8.625H2.20825ZM6.79159 1.75H2.20825V7.70833H6.79159V1.75ZM3.12492 6.79167H4.04159V2.66667H3.12492V6.79167ZM4.95825 6.79167H5.87492V2.66667H4.95825V6.79167Z",
    fill: "#FFCF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowDelete);
export default __webpack_public_path__ + "static/media/yellowDelete.0f1f707491e6b2b5fc696532b3621982.svg";
export { ForwardRef as ReactComponent };